<div
  class="layout-wrapper"
  [class.layout-sidebar-active]="sidebarOpen"
  [class.layout-mobile]="isMobile"
>
  <app-header class="layout-topbar-fixed"></app-header>

  <div class="layout-sidebar">
    <app-sidebar></app-sidebar>
  </div>

  <div class="layout-main-container">
    <div class="layout-main">
      <router-outlet></router-outlet>
    </div>
  </div>

  <div *ngIf="isMobile && sidebarOpen" class="layout-mask" (click)="closeMobileMenu()"></div>
</div>
